import axios from '../axios'

/*
 * 缴费管理
 */

// 删除 ids(多个Id用,分隔)
export const batchDelete = (data) => {
  return axios({
    url: '/mPayCost/delete',
    method: 'post',
    data
  })
}
/**
 * 缴费列表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const list = (data) => {
  return axios({
    url: '/mPayCost/list',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 * 保存缴费
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const save = (data) => {
  return axios({
    url: '/mPayCost/save',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/payCost.js